import { creatorbase } from '@round/api';
import { Modal } from '@round/whitelabel-ui';
import { showNotification } from 'helpers';
import styles from './DeleteReportModal.module.css';
import cn from 'classnames';
import { Button } from '@round/whitelabel-ui';
import { useDeleteReportMutation } from '@round/creatorbase-helpers/api-hooks';

type Props = {
    isOpen: boolean;
    onClose: () => void;
    report: creatorbase.Report | null;
};

const DeleteReportModal = ({ isOpen, onClose, report }: Props) => {
    const { deleteOne, isLoading } = useDeleteReportMutation(report?.id);
    const handleDelete = async () => {
        if (!report?.id) {
            return;
        }

        try {
            await deleteOne(report.id);
            showNotification('Report deleted', 'info');
            onClose();
        } catch {
            showNotification('Could not delete report', 'error');
        }
    };

    const handleClose = () => {
        if (isLoading) {
            return;
        }

        onClose();
    };

    return (
        <Modal className={styles.modal} closeOnOverlayClick={!isLoading} isOpen={isOpen} onClose={handleClose}>
            <Modal.Header>
                <Modal.Title>Delete Report</Modal.Title>
            </Modal.Header>

            <Modal.Body className={styles.body}>
                <p className={cn(styles.copy, styles.bold)}>You're about to permanently delete the following:</p>
                <div className={styles.banner}>
                    <p className={cn(styles.copy, styles.bold)}>Report:</p>
                    {report && (
                        <>
                            <p className={styles.copy}>{report.name}</p>
                            <p className={styles.copy}>{report.description}</p>
                        </>
                    )}
                </div>

                <p className={styles.copy}>You cannot restore reports. They are deleted permanently.</p>
            </Modal.Body>

            <Modal.Actions>
                <Button
                    appearance="critical"
                    disabled={!report?.id || isLoading}
                    isLoading={isLoading}
                    onClick={handleDelete}
                >
                    Delete Report
                </Button>
                <Button appearance="ghost" onClick={handleClose} disabled={isLoading}>
                    Cancel
                </Button>
            </Modal.Actions>
        </Modal>
    );
};

export default DeleteReportModal;
